<template>
    <div class="flex float-left vertical-center">
        <vs-button size="small" icon-pack="feather" icon="icon-eye" @click="detailRecord" color="warning" class="mr-2"></vs-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActionDetailGridComponent",
        data() {
            return {
                filter : {}
            }
        },
        methods: {
            detailRecord(){
                this.$root.$emit("detail-from-ActionDetailGridComponent", this.params.value)
            }
        },
        created() {
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>